module.exports = __webpack_public_path__ + "03dd27bff562cdaa60cd908c95237578.svg";